// extracted by mini-css-extract-plugin
export var table = "Table-module--table--ecca5";